import axios from 'axios';
//TODO: implement
const ImageService = {
    async uploadImages(images){
        
        const formData = new FormData();
        images.forEach(image => {
            formData.append(image.type,image.file)
        });

        const res = await axios.put(`/api/images`,formData,{
            headers:{
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((res) => {
            return {
                message: 'images uploaded succesfully',
                succeded: true,
                images: res.data.images
            }
        })
        .catch((err) => {
            return {
                message: 'image upload failed',//TODO: CHANGE TO ERR.MESSAGE?
                succeded: false,
                error: err
            }
        });

        //TODO: think what it should return here based on the status?
        return res;
    }
}

export default ImageService;